'use strict';

/**
 * @function
 * @description Scrolls a browser window to a given x point
 * @param {String} The x coordinate
 */
const scrollBrowser = (xLocation) => {
    $('html, body').animate({scrollTop: xLocation}, 500);
};

module.exports = scrollBrowser;
